import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import { getItems } from './getItems';

const getItem = (
    id: string,
    itemShape: ItemResponseShape,
    shapeName?: string
): Promise<SingleResponseMessage> => getItems([id], itemShape, shapeName).then(items => items?.[0]);

export default getItem;
